import PropTypes from "prop-types";
import TickIcon from "../../../../assets/icons/tick.svg";
import styles from "./FilterSelection.module.scss";

export default function FilterSelection({
  children,
  disabled = false,
  showCheckbox = false,
  checked = false,
  onClick,
  label,
}) {
  const renderCheckBox = () => {
    if (showCheckbox && !checked) {
      return (
        <input
          id={`${label.toLowerCase().replace(/\s+/g, "-")}`}
          className={styles.filterCheckbox}
          type="checkbox"
          aria-checked={checked}
          aria-label={label}
          checked={checked}
          readOnly
        />
      );
    }

    if (checked) {
      return <img className={styles.filterIcon} src={TickIcon} alt="Tick" />;
    }

    return null;
  };

  return (
    <li
      className={`${styles.filterSelection} ${
        checked ? styles["filterSelection--active"] : ""
      }`.trim()}
    >
      <button
        role="button"
        className={styles.filterSelectionContent}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
        {renderCheckBox()}
      </button>
    </li>
  );
}

FilterSelection.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  showCheckbox: PropTypes.bool,
  checked: PropTypes.bool,
};
